// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"08c105a4","56":"4e7c1567","311":"246df329","336":"9577bda9","380":"eb97c7ba","384":"2ebf21f9","392":"0ddf2d1b","417":"901bbb27","665":"ce43f9cf","895":"6d2b672b","912":"10fb85a2"}[chunkId] + ".chunk.js";
};